import { Inbox, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description: ReactNode;
  action?: ReactNode;
  docsHref?: string;
}

export function EmptyState({ icon: Icon = Inbox, title, description, action, docsHref }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 px-4 py-12 text-center">
      <Icon aria-hidden className="size-9 text-muted-foreground" />
      <h2 className="text-md font-semibold">{title}</h2>
      <p className="max-w-md text-muted-foreground">{description}</p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {action}
        {docsHref && (
          <a className="text-signal-text underline-offset-4 hover:underline" href={docsHref} target="_blank" rel="noopener noreferrer">
            Read the docs
          </a>
        )}
      </div>
    </div>
  );
}
